import { gsap } from "gsap";
import videojs from 'video.js';

export default class Modal {
    constructor() {
        this.modal = document.getElementById('dynamicModal');
        this.modalContent = document.getElementById('modalContent');
        this.closeModalBtn = document.getElementById('closeModal');
        this.currentPlayer = null;

        if( this.modal && this.modalContent && this.closeModalBtn ) {
            this.closeModalBtn.addEventListener('click', () => this.closeModal());

            window.addEventListener('click', (event) => {
                if( event.target === this.modal ) {
                    this.closeModal();
                }
            });

            this.initializeModalEvents(); // Initialiser les événements des boutons modaux
        } else {
            console.error('Modal elements not found');
        }
    }

    initializeModalEvents() {
        document.querySelectorAll('.btn-modal').forEach(button => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                const videoUrl = button.getAttribute('data-video-url');
                this.openModal(videoUrl);
            });
        });
    }

    openModal(videoUrl) {
        const videoElement = `<video id="videoPlayer" class="video-js" playsinline controls>
                                <source src="${videoUrl}" type="video/mp4">
                             </video>`;
        this.modalContent.innerHTML = videoElement;
        gsap.set(this.modal, {
            display: 'flex'
        });
        gsap.fromTo(this.modal.querySelector('.modal-content'), {
            y: '-100%',
            opacity: 0
        }, {
            y: '0%',
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        });

        this.initVideoJS();
    }

    initVideoJS() {
        const videoElement = this.modalContent.querySelector('#videoPlayer');
        if (videoElement) {
            this.currentPlayer = videojs(videoElement, {
                controls: true,
                autoplay: false,
                preload: 'auto',
                fluid: true,
                controlBar: {
                    playToggle: true,
                    volumePanel: {
                        inline: false
                    },
                    fullscreenToggle: true
                }
            });
        }
    }

    closeModal() {
        gsap.to(this.modal.querySelector('.modal-content'), {
            y: '-100%',
            opacity: 0,
            duration: 0.5,
            ease: 'power2.in',
            onComplete: () => {
                if (this.currentPlayer) {
                    this.currentPlayer.pause();
                    this.currentPlayer.dispose();
                    this.currentPlayer = null;
                }
                gsap.set(this.modal, {
                    display: 'none'
                });
                this.modalContent.innerHTML = '';
            }
        });
    }
}
